module.exports = __webpack_public_path__ + "img/good2.463c149d.png";